import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Comment from './Comment'
import ProgressiveButton from 'views/pages/ProgressiveButton'
import AssignTabs from 'views/pages/AssignTabs'
import Search from 'views/pages/Search'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import File from 'views/pages/File'
import ThumbnailInput from './ThumbnailInput'
import ToggleRow from './ToggleRow'
import { useDispatch } from 'react-redux'
import CustomModal from 'views/pages/CustomModal'
import TextEditor from 'views/pages/TextEditor'
import {
  Button,
  Input,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'
import Select from 'views/pages/Select'
import { useSelector } from 'react-redux'
import { setCurrentTab, syncSelectedFolder } from 'store/Library/actions'

//the functions being dispatched in this file are passed by parent props {..libraryActions}

const languageOptions = [
  { name: 'English', value: 1 },
  { name: 'Spanish', value: 3 },
]

const UpdateFile = (props) => {
  let language = props.language || {}

  const [folders, setFolders] = useState('')
  const [changedFolder, setChangedFolder] = useState(false)
  const { pdfjsDownloadAndPrint, enableLanguageFiles } = useSelector(
    (store) => store.generalConfig,
  )

  const dispatch = useDispatch()
  const thumbnailInputRef = useRef(null)
  useEffect(() => {
    dispatch(props.fetchAssignedItems(props.match.params.id))

    const file = props.library.allLibrary.find(
      (item) => item.id == props.match.params.id,
    )

    if (!file) {
      dispatch(props.fetchFiles())
    } else {
      file.scope === 'public'
        ? dispatch(props.setPublic('public'))
        : dispatch(props.setPublic('private'))
    }

    return () => {
      dispatch(props.setPublic('public'))
      dispatch(props.resetSelectedItems())
      dispatch(
        props.setCurrentTab(
          'category',
          'selectedOrgGroups',
          'groupOrgs',
          'toggleOrgGroups',
          'showSelectedOrgGroups',
          'setShowSelectedOrgGroups',
          'setHideSelectedOrgGroups',
        ),
      )
      dispatch(props.setAssignSearchValue(''))
      // Whatever "Move to" was set to here must not leak into the next modal.
      dispatch(syncSelectedFolder())
    }
  }, [])

  const file = props.library.allLibrary.find(
    (item) => item.id == props.match.params.id,
  )

  const isUrl =
    file?.type === 'file' &&
    !file?.path?.includes('cloudfront') &&
    !file?.path?.includes('destination-kiwi-uploads')

  const isPdf = file?.type === 'file' && file?.path?.endsWith('.pdf')

  const { enableCategories } = props.courseConfig

  const { allFolders, allFoldersNested } = props.library

  const defaultObj = {
    name: 'Select Folder',
    id: null,
  }
  const rootDirectory = {
    id: 'lib',
    name: 'Library',
    parent_id: 'lib',
  }

  const foldersNested = [defaultObj, rootDirectory, ...allFoldersNested]

  const handleFolderChange = (event) => {
    const folder = allFolders.find((folder) => folder.id === event.option.value)

    setFolders(folder)
    setChangedFolder(true)
    if (!folder) {
      dispatch(props.selectFolder('lib'))
    } else {
      dispatch(props.selectFolder(folder.id))
    }
  }

  const currentFile = props.library.allLibrary.find(
    (item) => item.id == props.match.params.id,
  )
  let folderValue = 'lib'
  if (currentFile && currentFile.parent_id) {
    folderValue = currentFile.parent_id
  }

  const flattenFolders = (folders, prefix = '') => {
    let flatList = []
    folders.forEach((item) => {
      flatList.push({ ...item, label: `${prefix}${item.name}` })
      if (item.children && item.children.length > 0) {
        flatList = flatList.concat(flattenFolders(item.children, `${prefix}--`))
      }
    })
    return flatList
  }

  // Flatten the nested folders structure with prefix
  const flattenedFolders = flattenFolders(foldersNested)

  // Generate options for react-select
  const selectOptions = flattenedFolders
    .filter(
      (item) =>
        item.name !== 'Library' &&
        item.name !== 'Select Folder' &&
        props.match.params.id !== item.id,
    )
    .map((item) => ({ value: item.id, name: item.label }))

  // Until the user picks a folder, show where the file really is. The store's
  // selection only counts once it was changed here (it may hold another folder).
  const shownFolderId = changedFolder
    ? props.library.selectedFolder
    : folderValue

  const selectedFolderInitial = selectOptions.find(
    (option) => option.value === shownFolderId,
  )

  const selectedFolder = selectedFolderInitial || {
    name: 'Library',
    id: 'lib',
  }

  const [activeFolder, setActiveFolder] = useState(selectedFolder?.name)

  const [fileLanguages, setFileLanguages] = useState([])
  const [noteContent, setNoteContent] = useState('')

  useEffect(() => {
    if (!file?.language) {
      setFileLanguages(languageOptions)
    } else {
      const option = languageOptions.find(
        (language) => language.value == file.language,
      )
      setFileLanguages(option ? [option] : languageOptions)
    }
  }, [file?.language])

  useEffect(() => {
    if (file && file.is_note === 1 && file.note_text) {
      setNoteContent(file.note_text)
    }
  }, [file])

  return (
    <CustomModal
      backPath={
        props.library.parentId
          ? '/library/folder/' + props.library.parentId
          : '/library'
      }
      title={file && file.is_note === 1 ? 'Update Note' : 'Update'}
      size='lg'
    >
      <ModalBody className='scrollbar'>
        <form
          id='update-file'
          onSubmit={(e) => {
            if (
              enableLanguageFiles &&
              (!fileLanguages || !fileLanguages?.length)
            ) {
              e.preventDefault()
              alert('Please select a language!')
              return
            }

            // For notes, validate content
            if (file && file.is_note === 1 && !noteContent.trim()) {
              e.preventDefault()
              alert('Please enter some content for the note!')
              return
            }

            if (!changedFolder) {
              dispatch(props.selectFolder(folderValue))
            }

            // For notes, we need to handle the update differently
            if (file && file.is_note === 1) {
              // // Create a FormData object and append note content
              // const formData = new FormData(e.target)
              // formData.set('note_text', noteContent)
              // formData.set('is_note', '1')

              // Call update with note-specific data
              dispatch(props.update(e, file.parent_id, fileLanguages))
            } else {
              // Regular file update
              dispatch(props.update(e, file.parent_id, fileLanguages))
            }
          }}
        >
          <div className='row'>
            <div className='col-12'>
              <div className='d-flex'>
                <Input
                  style={{ flex: '1 1 auto' }}
                  type='text'
                  defaultValue={file ? file.name : ''}
                  placeholder={
                    language.settings ? language.settings.title : null
                  }
                />

                <input type='hidden' value={props.match.params.id} />

                <input type='hidden' value={file ? file.type : ''} />
                {props.gridView && (
                  <Link
                    onClick={() =>
                      dispatch(props.deleteFile(props.match.params.id))
                    }
                    to={
                      props.library.parentId
                        ? '/library/folder/' + props.library.parentId
                        : '/library'
                    }
                  >
                    <Button
                      color='danger'
                      outline
                      className='d-flex align-items-center ml-3'
                    >
                      <FontAwesomeIcon icon={faTrash} />
                      <span>
                        {language.general ? language.general.delete : null}
                      </span>
                    </Button>
                  </Link>
                )}
              </div>
            </div>
          </div>
          {isUrl && (
            <div className='row'>
              <div className='col-12 mt-2'>
                <Input
                  style={{ flex: '1 1 auto' }}
                  type='text'
                  defaultValue={file ? file.path : ''}
                  placeholder={
                    language.settings ? language.settings.title : null
                  }
                />
              </div>
            </div>
          )}

          {/* Only show file input for non-notes and non-folders */}
          {file && file.is_note !== 1 && file.type !== 'folder' && (
            <div className='row mt-2'>
              <div className='col-6'>
                <File
                  language={language}
                  placeholder={
                    language.general ? language.general.choose_file : null
                  }
                />
              </div>
            </div>
          )}
          <div className='row'>
            <div className='col-12 d-flex align-items-center'>
              <ThumbnailInput
                inputRef={thumbnailInputRef}
                placeholder={
                  language.my_library
                    ? language.my_library.choose_thumbnail
                    : 'Choose thumbnail'
                }
                currentImageUrl={file?.thumbnail || null}
              />
            </div>
          </div>
          {file && file.type !== 'folder' && file.is_note !== 1 && (
            <div className='row mt-3'>
              <div className='col-12'>
                <ToggleRow
                  id='update-new-tab'
                  name='new_tab'
                  label='Open in new tab'
                  defaultChecked={file.new_tab !== 0}
                />
              </div>
            </div>
          )}
          {!pdfjsDownloadAndPrint && isPdf && (
            <div className='row mt-3'>
              <div className='col-12'>
                <ToggleRow
                  id='update-show-print-download'
                  name='showPrintDownload'
                  label='Show print / download'
                  defaultChecked={file?.show_print_download === 1}
                />
              </div>
            </div>
          )}
          <div className='row'>
            {enableLanguageFiles && file.type !== 'folder' ? (
              <div className='col-5 my-3'>
                <label>Language</label>
                <Select
                  options={languageOptions}
                  onChange={(selected) => {
                    setFileLanguages(selected)
                  }}
                  language={language}
                  placeholder={'Select Language'}
                  multi={true}
                  selectedOptions={fileLanguages}
                />
              </div>
            ) : null}
            <div className='col-8 d-flex align-items-center my-1'>
              <div className='custom-control custom-radio  mr-3'>
                <input
                  className='custom-control-input mr-2'
                  type='radio'
                  name='accessible'
                  id='set-public'
                  checked={props.library.scope === 'public'}
                  onChange={() => dispatch(props.setPublic('public'))}
                />
                <label className='custom-control-label' htmlFor='set-public'>
                  {language.my_library ? language.my_library.public : null}
                </label>
              </div>

              <div className='custom-control custom-radio '>
                <input
                  className='custom-control-input mr-2'
                  type='radio'
                  name='accessible'
                  id='set-private'
                  checked={props.library.scope === 'private'}
                  onChange={() => dispatch(props.setPublic('private'))}
                />
                <label className='custom-control-label' htmlFor='set-private'>
                  {language.my_library ? language.my_library.private : null}
                </label>
              </div>
            </div>
            {props.library.scope === 'private' ? (
              // <div className="mar-top-20 mar-bot-20 col-4">
              <div className='col-4'>
                <Search
                  placeholder={
                    language.general ? language.general.search : null
                  }
                  value={props.assignSearchValue}
                  onChange={(event) =>
                    dispatch(props.setAssignSearchValue(event.target.value))
                  }
                />
              </div>
            ) : null}
            <div className='col-5'>
              <label>Move to</label>
              <Select
                options={[{ name: 'Libary', id: 'lib' }, ...selectOptions]}
                onChange={(e) => {
                  setActiveFolder(e.option.name)
                  handleFolderChange(e)
                }}
                language={language}
                placeholder={activeFolder}
                multi={false}
                selectedOption={selectedFolder}
              />
              {/* <Input
                name='folders'
                className='w-25'
                type='select'
                onChange={(e) => handleFolderChange(e)}
                defaultValue={folderValue}
              >
                {foldersNested &&
                  foldersNested.map((item, index) => {
                    if (props.match.params.id != item.id) {
                      return <Comment key={item.id} subFolder={item} />
                    }
                  })}
              </Input> */}
            </div>
          </div>

          {props.library.scope === 'private' ? (
            <div>
              <div className='d-flex mt-1 mb-1'>
                <Nav
                  className='nav-fill flex-column flex-sm-row col-12 p-2 rounded'
                  id='tabs-text'
                  style={{ backgroundColor: '#f6f9fc' }}
                  pills
                  role='tablist'
                >
                  <NavItem className='nav-items'>
                    <NavLink
                      aria-selected={props.library.currentTab === 'category'}
                      className={`mb-sm-3 mb-md-0 py-2 bg-transparent font-weight-bold 
																${
                                  props.library.currentTab === 'category'
                                    ? 'active-item active-link'
                                    : 'nav-item'
                                }`}
                      onClick={() =>
                        dispatch(
                          props.setCurrentTab(
                            'category',
                            'selectedOrgGroups',
                            'groupOrgs',
                            'toggleOrgGroups',
                            'showSelectedOrgGroups',
                            'setShowSelectedOrgGroups',
                            'setHideSelectedOrgGroups',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                    >
                      {language.general
                        ? language.general.category
                        : 'Category'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={props.library.currentTab === 'user'}
                      className={`mb-sm-3 mb-md-0 py-2  bg-transparent font-weight-bold 
													${
                            props.library.currentTab === 'user'
                              ? 'active-item active-link'
                              : 'nav-item'
                          }`}
                      onClick={() =>
                        dispatch(
                          props.setCurrentTab(
                            'user',
                            'selectedUsers',
                            'users',
                            'toggleUsers',
                            'showSelectedUsers',
                            'setShowSelectedUsers',
                            'setHideSelectedUsers',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                      color='none'
                    >
                      {language.general ? language.general.users : 'Users'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={
                        props.library.currentTab === 'location-group'
                      }
                      className={`mb-sm-3 mb-md-0 py-2  bg-transparent font-weight-bold 
																${
                                  props.library.currentTab === 'location-group'
                                    ? 'active-item active-link'
                                    : 'nav-item'
                                }`}
                      onClick={() =>
                        dispatch(
                          props.setCurrentTab(
                            'location-group',
                            'selectedLocationGroups',
                            'locationGroups',
                            'toggleLocationGroups',
                            'showSelectedLocationGroups',
                            'setShowSelectedLocationGroups',
                            'setHideSelectedLocationGroups',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                    >
                      {language.general
                        ? language.general.location_categories
                        : 'Location Groups'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={props.library.currentTab === 'stores'}
                      className={`mb-sm-3 mb-md-0 py-2  bg-transparent font-weight-bold 
													${
                            props.library.currentTab === 'stores'
                              ? 'active-item active-link'
                              : 'nav-item'
                          }`}
                      onClick={() =>
                        dispatch(
                          props.setCurrentTab(
                            'stores',
                            'selectedStores',
                            'stores',
                            'toggleStores',
                            'showSelectedStores',
                            'setShowSelectedStores',
                            'setHideSelectedStores',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                    >
                      {language.settings
                        ? language.settings.location
                        : 'Location'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={props.library.currentTab === 'job-title'}
                      className={`mb-sm-3 mb-md-0 py-2 bg-transparent font-weight-bold 
																${
                                  props.library.currentTab === 'job-title'
                                    ? 'active-item active-link'
                                    : 'nav-item'
                                }`}
                      onClick={() =>
                        dispatch(
                          props.setCurrentTab(
                            'job-title',
                            'selectedRoles',
                            'roles',
                            'toggleRoles',
                            'showSelectedRoles',
                            'setShowSelectedRoles',
                            'setHideSelectedRoles',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                    >
                      {language.settings
                        ? language.settings.assign_job_title
                        : 'Job Title'}
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>

              <AssignTabs
                items={props[props.library.currentItems]}
                toggleItem={props[props.library.currentToggleFunction]}
                selectedItems={props.library.currentSelectedItems}
                mainProps={props.library}
                assignSearchValue={props.library.assignSearchValue}
                setHideSelectedItems={
                  props[props.library.currentHideSelectedItemsFunction]
                }
                setShowSelectedItems={
                  props[props.library.currentShowSelectedItemsFunction]
                }
                showSelectedItems={
                  props.library[props.library.currentShowSelectedItems]
                }
                language={props.language}
                resetSelectedItems={() => dispatch(props.resetSelectedItems())}
                setCurrentTab={setCurrentTab}
                setAssignSearchValue={(event) =>
                  dispatch(props.setAssignSearchValue(event.target.value))
                }
                setPublic={(val) => dispatch(props.setPublic(val))}
                enableCategories={enableCategories}
              />
            </div>
          ) : null}

          {/* Note Content Editor - placed at the end for notes */}
          {file && file.is_note === 1 && (
            <div className='row mt-4'>
              <div className='col-12'>
                <label>Note Content</label>
                <TextEditor
                  customStyle='px-2'
                  textContent={noteContent}
                  onChangeText={(newContent) => setNoteContent(newContent)}
                  setOptions={{
                    buttonList: [
                      [
                        'undo',
                        'redo',
                        'font',
                        'fontSize',
                        'formatBlock',
                        'list',
                        'align',
                        'fontColor',
                      ],
                      ['bold', 'underline', 'italic', 'horizontalRule'],
                      ['codeView', 'outdent', 'indent'],
                      ['table', 'image', 'link', 'video'],
                    ],
                  }}
                />
                {/* Hidden input to pass note content in form submission */}
                <input type='hidden' name='note_text' value={noteContent} />
              </div>
            </div>
          )}
        </form>
      </ModalBody>
      <ModalFooter className='py-3 border-top'>
        <ProgressiveButton
          percent={props.library.libraryUploadPercent}
          status={props.library.fileUploadStatus}
          placeholder={language.general ? language.general.submit : null}
          language={props.language}
          form='update-file'
          type='submit'
        />
        <Link
          to={
            props.library.parentId
              ? '/library/folder/' + props.library.parentId
              : '/library'
          }
          className='btn py-2 btn-transparent active-link'
        >
          {language.general ? language.general.cancel : null}
        </Link>
      </ModalFooter>
    </CustomModal>
  )
}

export default UpdateFile
